import { ReactComponent as InstalledIcon } from "../../../../../assets/images/power-assets/installed.svg";
import { ReactComponent as UpgradedIcon } from "../../../../../assets/images/power-assets/upgraded.svg";
import { ReactComponent as CorrectiveMaintenanceIcon } from "../../../../../assets/images/power-assets/correctiveMaintenance.svg";
import { ReactComponent as PreventiveMaintenanceIcon } from "../../../../../assets/images/power-assets/preventiveMaintenance.svg";
import { ReactComponent as RemoveIcon } from "../../../../../assets/images/icons/remove.svg";
import { COLORS } from "../../../../../theme/colors";

export function assetDetailActivitiesDataNormalizer(powerAssetActivities) {
  return powerAssetActivities.map((powerAssetActivity) => {
    let icon, circleStrokeColor;
    let height = 100,
      iconColor = COLORS.white,
      strokeDash,
      lineStrokeColor = "black",
      circleFillColor = COLORS.purple;

    switch (powerAssetActivity.text) {
      case "Installed":
      case "Installation":
        icon = InstalledIcon;
        height = 50;
        break;
      case "Upgraded":
        icon = UpgradedIcon;
        break;
      case "Corrective maintenance":
        icon = CorrectiveMaintenanceIcon;
        break;
      case "Upcoming preventive maintenance":
        icon = PreventiveMaintenanceIcon;
        iconColor = COLORS.davisGrey;
        height = 50;
        lineStrokeColor = COLORS.darks[0][25];
        circleStrokeColor = COLORS.darks[0][50];
        circleFillColor = "none";
        strokeDash = "6";
        break;
      default:
        icon = RemoveIcon;
        break;
    }

    return {
      id: powerAssetActivity.id,
      date: new Date(powerAssetActivity.date).getTime(),
      text: powerAssetActivity.text,
      height,
      icon,
      iconColor,
      lineStrokeColor,
      circleStrokeColor,
      circleFillColor,
      strokeDash,
    };
  });
}
